const { utcToZonedTime, format } = require("date-fns-tz");
export const getCreatedAt = (timeString) => {
  const date = new Date(timeString);
  const timeZone = "PST";
  const zonedDate = utcToZonedTime(date, timeZone);
  const pattern = "MMM dd yyyy";
  return format(zonedDate, pattern, { timeZone });
};
